import React, { forwardRef } from "react";
import { Box, Input, Select } from "@chakra-ui/react";

type InputSelectProps = {
  name: string;
  value?: string;
  placeholder?: string;
  disabled?: boolean;
  fontSize?: string;
  height?: string;
  paddingY?: string;
  options: { label: string; value: string; disabled?: boolean }[];
  onChange?: (value: string) => void;
  onBlur?: () => void;
  dataTestPrefix?: string;
  autocomplete?: string;
};

export const InputSelect = forwardRef<HTMLSelectElement, InputSelectProps>((props, ref) => {
  const {
    name,
    value,
    placeholder,
    disabled,
    fontSize = "xl",
    height = "auto",
    paddingY = 4,
    options,
    onChange,
    onBlur,
    autocomplete,
  } = props;
  const dataTestPrefix = props.dataTestPrefix ?? name;

  return (
    <Select
      data-testid={`${dataTestPrefix}-select`}
      ref={ref}
      borderColor="gray.500"
      name={name}
      value={value ?? ""}
      placeholder={placeholder}
      width="max-content"
      maxWidth="full"
      _disabled={{
        opacity: 1,
      }}
      backgroundColor={disabled ? "gray.50" : "white"}
      disabled={disabled}
      isReadOnly={disabled}
      cursor={disabled ? "not-allowed" : "text"}
      fontSize={fontSize}
      size="lg"
      _hover={{
        borderColor: disabled ? "gray.500" : "blue.500",
      }}
      onChange={(e) => onChange?.(e.target.value)}
      onBlur={onBlur}
      autoComplete={autocomplete}
    >
      {options.map((option) => (
        <Box
          as="option"
          key={option.value}
          value={option.value}
          disabled={option.disabled}
          data-testid={`${dataTestPrefix}-option-${option.value}`}
        >
          {option.label}
        </Box>
      ))}
    </Select>
  );
});
